import { http } from "../../../common/http";

class SuccessStoryService {
	list = () => {
		return http({
			method: "GET",
			url: "/success-story"
		});
	};

	detail = (id: number) => {
		return http({
			method: "GET",
			url: `/success-story/${id}`,
		});
	};
}
export default new SuccessStoryService();
